/**************************************************
 * Nombre:       Escuela_Detalle_Portada
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import '@splidejs/react-splide/css';
import fondo from '../../../Recursos/fondos.png'
import {NEGRITA} from "../../../Constantes";
import tecni from '../../../Recursos/Temporales/equipo.png'
import {School} from '@mui/icons-material'
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";


const Escuela_Detalle_Portada = ({item}) => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                mt: -12,
                backgroundImage: `url(${fondo})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
            }}
        >


            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, color: '#fff', pt: sCell ? 4 : 12}}
            >

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 11}}>


                    <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                        >


                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                  sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: 12}}>
                                <Typography sx={{
                                    fontSize: sCell ? 40 : 60,
                                    fontWeight: 600,
                                    fontFamily: NEGRITA,
                                    lineHeight: 1.1,
                                    textAlign: sCell ? 'center' : 'left',
                                }}>

                                    <School sx={{
                                        fill: '#fff',
                                        height: sCell ? 44 : 62,
                                        width: sCell ? 44 : 62,
                                        pr: 2,
                                        ml: sCell ? -5 : 0,
                                        mt: 1,
                                        mb: -1,

                                    }}/>
                                    {item.nombre}
                                </Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                                <Typography sx={{
                                    fontSize: 18,
                                    fontWeight: sCell ? 600 : 400,
                                    textAlign: sCell ? 'center' : 'left',
                                }}>
                                    {item.descripcion}
                                </Typography>
                            </Grid>


                        </Grid>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 6}}
                          sx={{justifyContent: 'flex-end', mt: sCell ? 2 : 12}}>
                        <img src={item.img} width={sCell ? '100%' : '90%'}/>
                    </Grid>

                </Grid>


            </Grid>


        </Grid>
    )

}
export default Escuela_Detalle_Portada

